<script setup>
import Button from "@/components/ui/button/Button.vue";
import Item from "@/components/ui/item/Item.vue";
import ItemContent from "@/components/ui/item/ItemContent.vue";
import ItemDescription from "@/components/ui/item/ItemDescription.vue";
import ItemHeader from "@/components/ui/item/ItemHeader.vue";
import ItemMedia from "@/components/ui/item/ItemMedia.vue";
import ItemTitle from "@/components/ui/item/ItemTitle.vue";
import Separator from "@/components/ui/separator/Separator.vue";
import { CalendarDaysIcon, LaptopMinimalIcon, UserIcon } from "lucide-vue-next";

const emit = defineEmits(["onChangeClick"]);

defineProps({
  bookingId: String,
  bookingDate: String,
  user: String,
  seat: {
    type: String,
    default: "No seat booked",
  },
  eventDate: String,
  eventDetails: String,
  eventName: String,
});
</script>

<template>
  <Item variant="muted" class="mb-3">
    <ItemContent>
      <ItemHeader class="font-semibold text-md"> Congratulations! </ItemHeader>
      <ItemDescription>
        <div class="mb-2">
          Your ticket for
          <p class="font-bold inline">"{{ eventName }}"</p>
          is successfully booked
        </div>
        <div class="font-semibold text-xs text-foreground">
          Today's Date: {{ bookingDate }}
        </div>
      </ItemDescription>
    </ItemContent>
  </Item>
  <div>
    <div class="flex flex-row items-center">
      <h1 class="grow">Booking Details</h1>
      <Button
        variant="ghost"
        class="font-bold text-primary text-xs uppercase"
        @click="emit('onChangeClick')"
        >Change</Button
      >
    </div>
    <Item class="pb-0">
      <ItemMedia><UserIcon class="text-muted-foreground" /></ItemMedia>
      <ItemContent class="gap-0">
        <ItemDescription class="text-xs">User</ItemDescription>
        <ItemTitle>{{ user }}</ItemTitle>
      </ItemContent>
    </Item>
    <Item class="pb-0">
      <ItemMedia><LaptopMinimalIcon class="text-muted-foreground" /></ItemMedia>
      <ItemContent class="gap-0">
        <ItemDescription class="text-xs">Seat</ItemDescription>
        <ItemTitle>{{ seat }}</ItemTitle>
      </ItemContent>
    </Item>
    <Item>
      <ItemMedia><CalendarDaysIcon class="text-muted-foreground" /></ItemMedia>
      <ItemContent class="gap-0">
        <ItemDescription class="text-xs">Event Date</ItemDescription>
        <ItemTitle>{{ eventDate }}</ItemTitle>
      </ItemContent>
    </Item>
    <div v-if="eventDetails">
      <Separator class="mb-4"></Separator>
      <h1>Event Details</h1>
      <p class="text-xs text-muted-foreground">{{ eventDetails }}</p>
    </div>
  </div>
  <div class="h-12"></div>
</template>
